

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/message/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _util = require('../fi-contingency-list/util');

var _fi = require('xo-models/src/fi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBankFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },

        controller: ['$scope', '$element', function ($scope, $element) {

            function handleContingency(name, result) {

                $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(result, 'bank');
                _util.$fiErrorUtil.addFieldErrors(result, $element, 'model.');
                _uiRouter.$state.go('^.add');
            }

            function updateFundingOptions() {
                $scope.checkoutSession.fundingOptions.action('update', {

                    resultModel: $scope.checkoutSession,

                    data: {
                        planId: $scope.bankId
                    },
                    success: function success(result) {

                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        $scope.parentCallbacks.done();
                    },
                    contingencies: {
                        ADD_BANK_CONTINGENCY: handleContingency
                    }

                });
            }

            $scope.setBankPrefer = false;

            $scope.callbacks = {
                addBankDone: function addBankDone(bank) {
                    $scope.bank = bank;
                    _uiRouter.$state.go('^.sepa');
                },
                setBankPrefer: function setBankPrefer(bSetBank) {
                    $scope.setBankPrefer = bSetBank;
                },

                sepaDone: function sepaDone() {

                    (0, _squid.$populate)($scope, {
                        checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                        cart: _index.$CheckoutCartModel.instance($scope.token)
                    }).then(function () {

                        $scope.locale = _squid.$locale;

                        var addBankReq = $scope.bank.getBankData();

                        $scope.bank.action('add', {

                            data: addBankReq,

                            resultModel: {},

                            success: function success(data) {

                                $scope.bankId = data.id;

                                // setPreferredFI checkbox is checked
                                if ($scope.setBankPrefer) {

                                    _logger.$logger.info('set_preferredFI_checked');

                                    // set preferred FI before updating
                                    var preferredFi = new _fi.$PreferredFi({
                                        preferred: [$scope.bankId]
                                    });

                                    preferredFi.save({
                                        success: function success() {
                                            _logger.$logger.info('SET_PREFERREDFI_SUCCESS', { preferred: [$scope.bankId] });
                                        },
                                        transientError: true,
                                        error: function error(err) {
                                            // log the error but fails silently because card is added
                                            _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                        },
                                        contingencies: {
                                            DEFAULT: function DEFAULT(name, contingency) {
                                                _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                            }
                                        }
                                    });
                                }

                                // Sepa Mandate
                                var sepaStatus = data.sepaStatus;

                                if (sepaStatus === 'AUTHORIZED') {
                                    return updateFundingOptions();
                                }
                                $scope.bank.action('sepaAccept', {

                                    data: {
                                        bank: {
                                            id: data.id
                                        }
                                    },

                                    resultModel: {},

                                    success: updateFundingOptions,
                                    contingencies: {
                                        DEFAULT: handleContingency
                                    }

                                });
                            },

                            contingencies: {
                                ADD_BANK_CONTINGENCY: handleContingency
                            }

                        });
                    });
                },

                cancel: $scope.parentCallbacks.cancel
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_util.$fiErrorUtil;

_fi.$PreferredFi;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/directive.js
// module chunks = 0